import { createSelector } from "@reduxjs/toolkit";
import { selectCurrentProjectId } from "../../../../../global/globalSliceCommon";
import { IRootState } from "../../../../../store";
import { issueBoardRTK } from "../../IssueBoardRTK";
import { selectIssueBoardId } from "./issueCommonSelectors";
import { IIssueBoardApi } from "@schemas/issueBoardSchema";
const EMPTY_ISSUE_BOARD: IIssueBoardApi | null = null;

export const selectIssueBoardQueryArgs = createSelector(
  [selectCurrentProjectId, selectIssueBoardId],
  (projectId, issueBoardId) => {
    if (!projectId || !issueBoardId) return undefined;
    return { projectId, issueBoardId };
  },
);

export const selectHttpIssueBoard = createSelector(
  [(state: IRootState) => state, selectIssueBoardQueryArgs],
  (state, args): IIssueBoardApi | null => {
    if (!args) return EMPTY_ISSUE_BOARD;
    const q = issueBoardRTK.endpoints.getSingleIssueBoard.select(args)(state);
    return q.data ?? EMPTY_ISSUE_BOARD;
  },
);
